import { IPowerbarStoreModule, registerAdapter, unregisterAdapter } from '../utils';
import { IMenuHistoryState } from './types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import state from './state';

const MenuHistoryState: IPowerbarStoreModule<IMenuHistoryState, any> = {
  name: 'MenuHistoryState',
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
MenuHistoryState.register = registerAdapter(MenuHistoryState);
MenuHistoryState.unregister = unregisterAdapter(MenuHistoryState);

export default MenuHistoryState;
